import React, { useEffect, useState } from "react";
import { Typography, Button, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import styles from './practitioner.module.css';
import FormField from "../FormComponent/FormField/FormField";
import { useForm } from "react-hook-form";
import { axiosProxyInstance } from "../../utils/request";
import cogoToast from "cogo-toast";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = yup.object({
    physiotherapistsCount: yup.string().required('Please select number of physiotherapists'),
});

const Practising = ({ sectionData, details }) => {

    const [defaultValues, setDefaultValues] = useState(null);
    const form = useForm({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues: {
            physiotherapistsCount: null
        }
    });
    const currentUserId = localStorage.getItem("LPCurrentUserId");
    const { register, handleSubmit, control, formState: { errors, isDirty }, reset } = form;
    const allFields = sectionData.fields.flatMap(field =>
        field.fields ? field.fields : [field]
    );
    const physiotherapistsCountField = allFields.find(field => field.id === "physiotherapistsCount");
    useEffect(() => {
        if (details) {
            let physiotherapistsCount;
            const num_workers = details?.data?.num_workers
            if (num_workers == 1) {
                physiotherapistsCount = "1-2";
            }
            if (num_workers == 3) {
                physiotherapistsCount = "3-4";
            }
            if (num_workers == 5) {
                physiotherapistsCount = "5+";
            }

            const resData = {
                physiotherapistsCount: physiotherapistsCount
            };
            reset(resData);
            setDefaultValues(resData)
        }
    }, [details, reset]);

    const onSubmit = async (data) => {
        const payload = {
            btn_submit: true,
            listings: [
                {
                    listing_id: details?.ID,
                    title: details?.post_title,
                    address_1: details?.data.address_1,
                    postcode: details?.data.postcode,
                    telephone_1: details?.data?.phone?.raw,
                    specialization: (Object.values(details.data.services || {})),
                    treatments: Object.values(details.data.treatments || {}),
                    num_workers: data?.physiotherapistsCount,
                    provideruid: currentUserId,
                    uid: currentUserId,
                }
            ]
        };
        try {
            const res = await axiosProxyInstance.post('/signup/2/', payload);
            cogoToast.success("Practising Physiotherapists Updated Successfully!");
        } catch (err) {
            console.error("Submission failed:", err);
        }
    }

    return (
        <Box>
            <Typography variant="gothamMedium">
                How many physiotherapists practise out of here?
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box className='margin-top-15'>
                    <Box style={{ flex: "1" }}>
                        <FormField
                            field={physiotherapistsCountField}
                            register={register}
                            control={control}
                            errors={errors}
                        />
                        <Box className={styles.submitButtonContainer}>
                            <Button
                                disabled={!isDirty}
                                className={styles.primaryButton}
                                size="large"
                                type="submit"
                            >
                                Save Changes
                            </Button>
                            <Button
                                disabled={!isDirty}
                                className={styles.secondaryButton}
                                size="large"
                                onClick={() => reset(defaultValues)}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </form>
        </Box>
    )
}
export default Practising
